// src/contexts/StoreContext.js
import React, { createContext, useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

// 1) Create the context object
export const StoreContext = createContext({
  store: null,
  loading: true,
});

// 2) Wrap your app in this provider to fetch the store once
export function StoreProvider({ children }) {
  const [store, setStore] = useState(null);
  const [loading, setLoading] = useState(true);
  const storeId = '50C99C99-FA3D-492D-B051-C5B7A2411DD4';

  useEffect(() => {
    async function fetchStore() {
      try {
        const snap = await getDoc(doc(db, 'stores', storeId));
        if (snap.exists()) {
          setStore({ id: snap.id, ...snap.data() });
        }
      } finally {
        setLoading(false);
      }
    }
    fetchStore();
  }, [storeId]);

  return (
    <StoreContext.Provider value={{ store, loading }}>
      {children}
    </StoreContext.Provider>
  );
}
